import { loadConversation, useHasTokenGenerator } from "@noa/client-store";
import { useEffect, type FunctionComponent } from "react";
import { useParams } from "react-router";
import { ChatLayout } from "~/screens/home/chat-layout";

/**
 * Existing-conversation route ("/conversation/:sessionId"). Loads the conversation by id on
 * mount (idempotent — a no-op when the store already holds it live, e.g. arriving via the
 * seamless redirect right after the first message). Gated on the token generator to avoid a
 * 401 on a cold deep-link before Clerk's token getter is registered.
 */
export const ConversationScreen: FunctionComponent = () => {
  const { sessionId = "" } = useParams();
  const hasTokenGenerator = useHasTokenGenerator();

  useEffect(() => {
    if (!hasTokenGenerator) return;
    void loadConversation(sessionId);
  }, [sessionId, hasTokenGenerator]);

  return <ChatLayout />;
};
